import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-cancel-circle',
  standalone: true,
  templateUrl: '../../assets/cancel-circle.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamCancelCircleIcon {}
